import { useEffect, useState } from "react";

/**
 * Брейкпоинты планшета. Возвращает { tablet, cols } — cols уже подобраны под
 * сетку каталога: 3 карточки в портрете iPad, 4-5 в ландшафте и на 13".
 * iPhone (<768px) остаётся без изменений: tablet=false.
 */
export function useTablet() {
  const read = () => {
    if (typeof window === "undefined") return { tablet: false, cols: 2, width: 390 };
    const w = window.innerWidth;
    return {
      tablet: w >= 768,
      cols: w >= 1280 ? 5 : w >= 1024 ? 4 : w >= 768 ? 3 : 2,
      width: w,
    };
  };
  const [state, setState] = useState(read);
  useEffect(() => {
    const onResize = () => setState(read());
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);
  return state;
}

export default useTablet;
